module.exports = "<h3>\n    {{heading}}\n</h3>\n\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/collapsible-panel/panel-filter-category/panel-filter-category.component.html
// module id = WFjL
// module chunks = 5